export type DeprecatedCustomerMonitorRoutePageId =
  | "known-issues:customer-2"
  | "known-issues:customer:details-2"
  | "anomaly-detection-2"
  | "anomaly-detection:details-2"
  | "analytics:alerts:labels-2"
  | "analytics:alerts-2"
  | "analytics:alerts:details-2"
  | "analytics:alerts:create-2"
  | "analytics:budgets-2"
  | "analytics:budgets:labels-2"
  | "analytics:budgets:create-2"
  | "analytics:budgets:details-2"
  | "analytics:budgets:view-2"
  | "ramp-plans-2"
  | "ramp-plans:edit-2"
  | "ramp-plans"
  | "ramp-plans:edit";

export type DeprecatedCustomerMonitorRouteConfig = {
  pageId: DeprecatedCustomerMonitorRoutePageId;
  route: string;
};

export const deprecatedCustomerMonitorRoutes: DeprecatedCustomerMonitorRouteConfig[] = [
  {
    pageId: "known-issues:customer-2",
    route: "/known-issues",
  },
  {
    pageId: "known-issues:customer:details-2",
    route: "/known-issues/:knownIssueId",
  },
  {
    pageId: "anomaly-detection-2",
    route: "/anomaly",
  },
  {
    pageId: "anomaly-detection:details-2",
    route: "/anomaly/:assetId/:alertId",
  },
  {
    pageId: "analytics:alerts:labels-2",
    route: "/analytics/alerts/labels",
  },
  {
    pageId: "analytics:alerts-2",
    route: "/analytics/alerts",
  },
  {
    pageId: "analytics:alerts:details-2",
    route: "/analytics/alerts/:alertId",
  },
  {
    pageId: "analytics:alerts:create-2",
    route: "/analytics/alerts/create",
  },
  {
    pageId: "analytics:budgets-2",
    route: "/analytics/budgets",
  },
  {
    pageId: "analytics:budgets:labels-2",
    route: "/analytics/budgets/labels",
  },
  {
    pageId: "analytics:budgets:create-2",
    route: "/analytics/budgets/create",
  },
  {
    pageId: "analytics:budgets:details-2",
    route: "/analytics/budgets/:budgetId",
  },
  {
    pageId: "analytics:budgets:view-2",
    route: "/analytics/budgets/:budgetId/view",
  },
  {
    pageId: "ramp-plans-2",
    route: "/contracts/ramps",
  },
  {
    pageId: "ramp-plans:edit-2",
    route: "/contracts/ramps/:rampId",
  },
  {
    pageId: "ramp-plans",
    route: "/monitor/ramp-plans",
  },
  {
    pageId: "ramp-plans:edit",
    route: "/monitor/ramp-plans/:rampId",
  },
];
